import { createSlice } from '@reduxjs/toolkit';
import { STATUS_LOADING } from 'common/constants';

import { IState, STATE } from '../types/state';

import setFavoriteCatalogsStatusLoading from './setFavoriteCatalogsStatusLoading';
import setFavoriteCatalogs from './setFavoriteCatalogs';
import setCatalogStations from './setCatalogStations';
import setCatalogStationsStatusLoading from './setCatalogStationsStatusLoading';

import updateFavoriteCatalogName from './updateFavoriteCatalogName';

import addStationsToCatalog from './addStationsToCatalog';
import removeStationFromCatalog from './removeStationFromCatalog';

import addNewCatalog from './addNewCatalog';
import addNewCatalogWithStation from './addNewCatalogWithStation';
import removeCatalog from './removeCatalog';
import renameCatalog from './renameCatalog';

const initialState: IState = {
  catalogs: {
    statusLoading: STATUS_LOADING.load,
    data: {},
  },
};

const slice = createSlice({
  name: STATE,
  initialState,
  reducers: {
    setFavoriteCatalogs,
    setFavoriteCatalogsStatusLoading,

    setCatalogStations,
    setCatalogStationsStatusLoading,

    addNewCatalog,
    updateFavoriteCatalogName,

    addStationsToCatalog,
    removeStationFromCatalog,

    addNewCatalogWithStation,

    removeCatalog,
    renameCatalog,
  },
});

export default slice;
